import BlockRenderer from "@/cms/BlockRenderer";

/** Renders the real public block components against the draft — preview
 * is never a separate mock, so what you see here is what Publish ships.
 * Full-width (not squeezed into a side panel): most sections are
 * full-bleed/dark-background designs that would misrepresent themselves
 * at half width. */
export default function PreviewPane({ blocks }) {
  return (
    <div className="rounded-2xl border border-gray-200 overflow-hidden">
      <div className="bg-[#0B2421] max-h-[75vh] overflow-y-auto">
        <BlockRenderer blocks={blocks} />
      </div>
    </div>
  );
}
